export abstract class SystemConfigurationSettingNames {
  public static readonly Domain = 'Domain';
}
